<template>
    <div class="">
		<div class="tab-content" id="myTabContent">
			<div class="tab-pane fade show active" id="new" role="tabpanel" aria-labelledby="new-tab">
				<div class="table-holder" v-if="leaves != ''">
					<table id="myLeaveTable" class="table" style="width:100%">
						<thead>
                            <tr>
                                <th>Date</th>
                                <th>Leave Type</th>
                                <th>Line Manager</th>
                                <th>Actions</th>
                            </tr>
						</thead>
						<tbody>
							<tr v-for="leave in leaves" :key="leave.id">
								<td>{{ leave.created_at | date_format }}</td>
								<td>{{ leave.leave_type }}</td>
								<td>{{ lineManagerName(leave.line_manager) }}</td>
								<td>{{ leave.id }}</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="leaves == ''">
					No leave data
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                leaves : null,
            };
        },
        mounted() {
            this.$Progress.start();
			this.listMyLeave();
        },
        methods: {
			listMyLeave(){
                this.$Progress.start();
                axios.get('/api/listMyLeave')
                .then(res => {
                    if(res.status == 200){
                        this.leaves = res.data.myLeaves;
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load data'
                        });
                    }
                })
                .catch(err => {
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Error to load data'
                    });
                });
			},
			lineManagerName(value){
				if(value == null){
					return '';
				}else{
					return value.name;
				}
			}
        },
        created() {
			//
        }
    }
</script>
